/* eslint-disable @typescript-eslint/no-explicit-any */

import CompoTitle from "@/pages/_common/CompoTitle";
import axios from "axios";
import { useEffect, useState } from "react";

import NoticeList from "./NoticeList";
import NewNoticeForm from "./NewNoticeForm";

export default function MainPage_Notice() {
  const [noticeData, setNoticeData] = useState<any>({
    list:[],
    count:0
  });

  useEffect(() => {    
    async function _getNoticeList() {
      const { data } = await axios.post("/notice/listup");
      setNoticeData({...data})
    }
    _getNoticeList();
  }, []);

  return (
    <div className="px-3">
      {/* 새글등록 */}
      <NewNoticeForm onUpdate={(noticeData:any)=>setNoticeData({...noticeData})}/>

      {/* 공지 목록 출력 */}
      <CompoTitle>
        <div className="flex items-center">
          <div className="flex-1">공지사항</div>
          <div className="text-[.8rem] text-zinc-500 font-normal self-end">
            총 {noticeData.count}개의 게시물이 있습니다.
          </div>
        </div>
      </CompoTitle>
      
      <NoticeList
        data={noticeData.list}
        className="px-2"
        onUpdate={(noticeData:any)=>setNoticeData({...noticeData})}
      />
      <div className="border-b border-zinc-300" />
    </div>
  );
}
